import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { ReturnInformationContainer, AttachmentDisplayContainer } from './styled'
import { isNullOrEmpty } from 'core/utilities'
import { FileUploadCell } from 'components'
import { uploadBgForm } from 'ducks/bankGuaranteeRequest'

const ReturnInformation = (props) => {
  const { valueForm={}, isDisplay=false, user } = props
  const [showReturnInfo, setShowReturnInfo] = useState(true)
  const [showUploadFile, setShowUploadFile] = useState(false)

  useEffect(() => {
  }, [])

  const editableForm = () => {
    const { status, sn } = valueForm
    if (status !== 0 && status !== undefined && status !== null) {
      return (status === 25 || status === 26) && !isNullOrEmpty(sn)
    } else {
      return !isDisplay
    }
  }

  const showReturnInfoSection = () => {
    const { status, returnedDate, requestType } = valueForm
    return (([4, 6].includes(status) && returnedDate !== null && returnedDate !== undefined) ||
           ([25, 26].includes(status)))
  }

  const showReturnInfoPart2 = () => {
    return valueForm.status === 26 || valueForm.status === 4 || valueForm.status === 6
  }

  return (
    showReturnInfoSection() ?
      <Card style={{ marginTop: '10px' }}>
        <CardHeader 
          title='Return Information'
          action={
            <IconButton aria-label='Expand' onClick={() => setShowReturnInfo(!showReturnInfo) }>
              {showReturnInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          }
        />
        <Collapse in={showReturnInfo}>
          <CardContent>
            <ReturnInformationContainer>
              <div className='rowFields'>
                <Field 
                  name='appointmentReturnDate' 
                  label='Appointment for Return Date' 
                  require 
                  editable={editableForm() && valueForm.status === 25} 
                  type={type.date} 
                  component={FieldInput} />
                <div className='rowFields'>
                  <Field 
                    name='returnTime' 
                    label='Appointment Time' 
                    require
                    editable={editableForm() && valueForm.status === 25} 
                    type={type.time} 
                    component={FieldInput} 
                  />
                  <Field 
                    name='returnTimeTo' 
                    label='To' 
                    require
                    editable={editableForm() && valueForm.status === 25} 
                    type={type.time} 
                    component={FieldInput} 
                  />
                </div>
              </div>
              {
                showReturnInfoPart2() ?
                <React.Fragment>
                  <div className='rowFields'>
                    <Field 
                      name='returnedDate' 
                      label='Return Date' 
                      require
                      editable={editableForm() && valueForm.status === 26}
                      type={type.date}
                      component={FieldInput} />
                    <Field type={type.empty} component={FieldInput} />
                  </div>
                  {
                    editableForm() && valueForm.status === 26 ?
                      <div className='rowFields'>
                        <Field 
                          name='BG05' 
                          label='BG Form (Signed by Vendor)' 
                          editable={editableForm() && valueForm.status === 26}
                          type={type.file}
                          component={FieldInput} />
                        <Field type={type.empty} component={FieldInput} />
                      </div> :
                      <AttachmentDisplayContainer>
                        <div className='title'>BG Form (Signed by Vendor)</div>
                        {
                          (valueForm.attachment05 || []).length === 0 ?
                          <div className='emptyFile'>No file uploaded.</div> : 
                          (valueForm.attachment05 || []).map(a =>
                            <FileUploadCell 
                              key={a.name}
                              fileName={a.originalFilename}
                              fileSize={a.size}
                              urlPath={a.urlPath||null} 
                              deletable={false}
                            />
                          )
                        }
                      </AttachmentDisplayContainer>
                  }
                  
                </React.Fragment> : null
              }
              {
                valueForm.status === 4 && user.isFinance && showUploadFile ?
                  <div className='rowFields'>
                    <Field 
                      name='newBG05' 
                      label='BG Form (Signed by Vendor)' 
                      editable={true}
                      type={type.file}
                      component={FieldInput} />
                    <Field type={type.empty} component={FieldInput} />
                  </div> : null
              }
              {
                valueForm.status === 4 && user.isFinance ?
                  <React.Fragment>
                    {
                      showUploadFile ?
                      <div className='rowFields'>
                        <Button
                          type='button'
                          content='Upload'
                          color='blue'
                          disabled={(valueForm.newBG05 || []).length === 0}
                          onClick={() => {
                            props.uploadBgForm(
                              valueForm.id,
                              { BG05: valueForm.newBG05 },
                              () => {
                                setShowUploadFile(false)
                                window.location.reload()
                              }
                            )
                          }}
                        />
                        <Button
                          type='button'
                          content='Cancel'
                          color='red'
                          onClick={() => setShowUploadFile(false)}
                        />
                      </div> :
                      <div className='rowFields'>
                        <Button
                          type='button'
                          content='Upload'
                          color='blue'
                          onClick={() => setShowUploadFile(true)}
                          /> 
                      </div>
                    }
                  </React.Fragment> : null
              }
            </ReturnInformationContainer>
          </CardContent>
        </Collapse>
      </Card> : null
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user || {}
  })
}
  
const mapDispatchToProps = {
  uploadBgForm
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnInformation)